import React, { useState, useEffect } from "react";
import { Row, Col, Spinner, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import DOMPurify from "dompurify";

// SVG Images
import Back from "../../assets/svg/back.svg";
import Cancel from "../../assets/svg/cancel.svg";
import Search from "../../assets/svg/search.svg";

//API
import SearchWithFreeTextAPI from "../common/searchbox-free-text";
import { UpdateLeadsApi } from "../leads/leads-api";
import {
  createCallsApi,
  getCallDetailsApi,
  getReminderListApi,
  UpdateCallsApi,
} from "./calls-api";
import SearchWithAPI from "../common/searchbox";
import AsyncSelect from "react-select/async";
import teamsIcon from "../../assets/svg/teams.svg";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../msalConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { getProfileDetailsApi } from "../common/common-api";

const CallsAdd = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  //useLocation
  const location = useLocation();
  const { id, moduleDetail, callFrom, prefill } = location.state || {};
  const isEdit = !!(location.state && location.state.id);
  //API URL
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiAccUrl = process.env.REACT_APP_ADMIN_API_URL;

  //Inputs
  const [callTitle, setCallTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const [followStartDate, setFollowStartDate] = useState("");
  const [followStartTime, setFollowStartTime] = useState("");
  const [followEndDate, setFollowEndDate] = useState("");
  const [followEndTime, setFollowEndTime] = useState("");
  const [subject, setSubject] = useState("");
  const [related, setRelated] = useState("");
  const [remarks, setRemarks] = useState("");
  const [followRemarks, setFollowRemarks] = useState("");
  const [selectedReminder, setSelectedReminder] = useState([]);
  const [selectedFollowReminder, setSelectedFollowReminder] = useState([]);
  const [reminder, setReminder] = useState(null);
  const [followReminder, setFollowReminder] = useState(null);
  const [callType, setCallType] = useState(null);
  const [callPurpose, setCallPurpose] = useState(null);
  const [followCallType, setFollowCallType] = useState(null);
  const [callFor, setCallFor] = useState("");
  const [leadOption, setLeadOption] = useState(null);
  const [teamsToken, setTeamsToken] = useState("");

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${year}/${month}/${day}`;
  };

  const [validations, setValidations] = useState({
    title: "",
    start_time: "",
    end_time: "",
    subject: "",
    related_to: "",
    call_type: "",
    call_purpose: "",
    call_for: "",
    call_for_id: "",
    parent_id: "",
    remarks: "",
    participants: "",
    reminders: "",
    follow_up: "",
    follow_up_call_type: "",
    follow_up_start_time: "",
    follow_up_end_time: "",
    follow_up_reminders: "",
    follow_up_remarks: "",
  });

  // Convert start date and time
  const start_time = `${startDate} ${startTime}:00`;
  const follow_start_time = `${followStartDate} ${followStartTime}:00`;

  // Convert end date and time
  const end_time = `${endDate} ${endTime}:00`;
  const follow_end_time = `${followEndDate} ${followEndTime}:00`;

  const [isTeamsEnable, setIsTeamsEnable] = useState(false);

  //Toggle Button
  const [isToggled, setIsToggled] = useState(false);
  const follow = isToggled;

  //Call Type Options
  const handleCallTypeChange = (e) => {
    setCallType(e.target.value);
  };

  //Follow Call Type
  const handleFollowCallTypeChange = (e) => {
    setFollowCallType(e.target.value);
  };

  //Call For Options
  const handleCallForChange = (e) => {
    setCallFor(e.target.value);
    setLeadOption(null);
  };

  const handleLeadDropdownChange = (option) => {
    if (option) {
      setLeadOption(option);
    }
  };

  const handleLeadOnChange = (term) => {};

  //Purpose of Call Options
  const handleCallPurposeDropdownChange = (option) => {
    console.log(option);
    setCallPurpose(option.label);
  };

  const handleCallPurposeOnChange = (term) => {
    setCallPurpose(term);
  };

  //Follow Call Type Options
  const handleFollowCallTypeDropdownChange = (option) => {
    console.log(option);
    setFollowCallType(option.label);
  };

  const handleFollowCallTypeOnChange = (term) => {
    setFollowCallType(term);
  };

  //Follow Reminder
  const handleFollowReminderDropdownChange = (option) => {
    console.log(option);
    setFollowReminder(option.label);
  };

  const handleFollowReminderOnChange = (selectedOptions) => {
    setSelectedFollowReminder(selectedOptions);
  };

  //Reminder
  const handleReminderDropdownChange = (option) => {
    console.log(option);
    setReminder(option.label);
  };

  const handleReminderOnChange = (selectedOptions) => {
    setSelectedReminder(selectedOptions);
  };

  // Search Participants

  const [searchInput, setSearchInput] = useState("");
  const [participants, setParticipants] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setSearchInput(val);

    const matching = participants.filter((p) =>
      p.toLowerCase().includes(val.toLowerCase()),
    );
    const dynamicOption = val && !participants.includes(val) ? [val] : [];
    setFilteredOptions([...matching, ...dynamicOption]);
  };

  const handleSelect = (name) => {
    if (!participants.includes(name)) {
      setParticipants((prev) => [...prev, name]);
    }
    setSearchInput("");
    setFilteredOptions([]);
  };

  const handleRemove = (name) => {
    setParticipants((prev) => prev.filter((p) => p !== name));
  };

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
          ? "#e0e0e0"
          : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({ ...provided, color: "#212129" }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": { backgroundColor: "red", color: "white" },
    }),
  };

  const getReminderData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getReminderListApi(inputValue ? `?term=${inputValue}` : "");
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0]?.toUpperCase())
      .join("")
      .slice(0, 2);
  };

  //Save Call
  const submitCall = async () => {
    try {
      setIsLoading(true);
      // An edited Teams call starts with the toggle on but no token yet.
      let accessToken = teamsToken;
      if (isTeamsEnable && !accessToken) {
        const tokenResponse = await instance
          .acquireTokenSilent({ ...loginRequest, account: accounts[0] })
          .catch(() => instance.loginPopup(loginRequest));
        accessToken = tokenResponse.accessToken;
        setTeamsToken(accessToken);
      }
      const dataBeforeSanitize = {
        title: callTitle ?? "",
        start_time: `${startDate} ${startTime}:00`,
        end_time: `${endDate} ${endTime}:00`,
        subject: subject ?? "",
        related_to: related ?? "",
        call_type: callType ?? "",
        call_purpose: callPurpose ?? "",
        call_for: callFor ?? "",
        call_for_id: leadOption !== null ? (leadOption?.value ?? "") : "",
        remarks: remarks ?? "",
        participants: participants ?? [],
        reminders: selectedReminder.map((item) => item.value) ?? [],

        follow_up: follow ?? false,
        follow_up_call_type: followCallType ?? "",
        follow_up_start_time:
          followStartDate && followStartTime
            ? `${followStartDate} ${followStartTime}${
                followStartTime.length === 5 ? ":00" : ""
              }`
            : "",
        follow_up_end_time:
          followEndDate && followEndTime
            ? `${followEndDate} ${followEndTime}${
                followEndTime.length === 5 ? ":00" : ""
              }`
            : "",
        follow_up_reminders:
          selectedFollowReminder.map((item) => item.value) ?? [],
        follow_up_remarks: followRemarks ?? "",
        thirdparty: isTeamsEnable ? "Microsoft-Teams" : "", //Microsoft-Teams
        accesstoken: accessToken,
      };

      const dataAfterSanitize = {};
      Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value) ||
          key === "assignee"
        ) {
          dataAfterSanitize[key] = value;
        } else {
          dataAfterSanitize[key] = DOMPurify.sanitize(value);
        }
      });

      let response;
      if (id != null) {
        response = await UpdateCallsApi(dataAfterSanitize, id);
      } else {
        response = await createCallsApi(dataAfterSanitize);
      }

      if (response.status === 200) {
        if (response.data.success === true) {
          navigate("/calls/list");
        }
        setIsLoading(false);
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            title: "",
            start_time: "",
            end_time: "",
            subject: "",
            related_to: "",
            call_type: "",

            call_purpose: "",
            call_for: "",
            call_for_id: "",
            remarks: "",
            participants: "",
            reminders: "",
            follow_up: "",
            follow_up_call_type: "",
            follow_up_start_time: "",
            follow_up_end_time: "",
            follow_up_reminders: "",
            follow_up_remarks: "",
          };

          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            const baseKey = key.includes(".") ? key.split(".")[0] : key;
            if (baseKey in validationTemp) {
              validationTemp[baseKey] =
                Array.isArray(value) && value.length > 0 ? value[0] : "";
            }
          });

          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    } catch (err) {
      console.error("Submit error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id != null) {
      getCallDetails();
    } else {
      const now = new Date();
      const startYear = now.getFullYear();
      const startMonth = String(now.getMonth() + 1).padStart(2, "0");
      const startDay = String(now.getDate()).padStart(2, "0");
      const startHours = String(now.getHours()).padStart(2, "0");
      const startMinutes = String(now.getMinutes()).padStart(2, "0");

      setStartDate(`${startYear}-${startMonth}-${startDay}`);
      setStartTime(`${startHours}:${startMinutes}`);

      const endNow = new Date(now.getTime() + 15 * 60 * 1000);
      const endYear = endNow.getFullYear();
      const endMonth = String(endNow.getMonth() + 1).padStart(2, "0");
      const endDay = String(endNow.getDate()).padStart(2, "0");
      const endHours = String(endNow.getHours()).padStart(2, "0");
      const endMinutes = String(endNow.getMinutes()).padStart(2, "0");

      setEndDate(`${endYear}-${endMonth}-${endDay}`);
      setEndTime(`${endHours}:${endMinutes}`);

      if (callFrom) {
        setCallFor(callFrom);
      }
      if (moduleDetail != null) {
        setCallFor(callFrom);
        setLeadOption(moduleDetail);
      }

      if (prefill) {
        if (prefill.title) setCallTitle(prefill.title);
        if (prefill.date) {
          setStartDate(prefill.date);
          setEndDate(prefill.date);
        }
        if (prefill.start_time) setStartTime(prefill.start_time);
        if (prefill.end_time) setEndTime(prefill.end_time);
        if (prefill.call_type) setCallType(prefill.call_type);
      }

      const fetchProfile = async () => {
        try {
          const response = await getProfileDetailsApi();
          if (response.status === 200 && response.data?.success) {
            const firstName = response.data.user.first_name || "";
            const email = response.data.user.email || "";
            const participant = email;

            if (participant) {
              setParticipants([participant]);
            }
          }
        } catch (err) {
          console.error("Error fetching profile:", err);
        }
      };
      fetchProfile();
    }
  }, []);

  const getCallDetails = async () => {
    try {
      const response = await getCallDetailsApi(id);
      console.log(response);
      if (response.status === true || response.call != null) {
        const callDetails = response.call; // Get the first call

        setCallTitle(callDetails.title ?? "");
        setStartDate(callDetails.start_date ?? "");
        setStartTime(callDetails.start_time ?? "");
        setEndDate(callDetails.end_date ?? "");
        setEndTime(callDetails.end_time ?? "");
        setSubject(callDetails.subject ?? "");
        setRelated(callDetails.related_to ?? "");
        setCallType(callDetails.call_type ?? "");
        setLeadOption({
          value: callDetails.call_for_id,
          label: callDetails.call_for_name,
        });
        setCallPurpose(callDetails.call_purpose ?? "");
        setCallFor(callDetails.call_for ?? "");
        setSelectedReminder(callDetails.reminders ?? []);
        setRemarks(callDetails.remarks ?? "");
        setParticipants(callDetails.participants ?? []);
        // Otherwise an edit never reaches Teams and the invite keeps the old time.
        // "0" is what failed Teams creates used to store.
        setIsTeamsEnable(!!callDetails.teams_id && String(callDetails.teams_id) !== "0");

        if (callDetails.followup_calls) {
          setIsToggled(true);
          setFollowCallType(callDetails.followup_calls.call_type ?? "");
          setFollowStartDate(callDetails.followup_calls.start_date ?? "");
          setFollowStartTime(callDetails.followup_calls.start_time ?? "");
          setFollowEndDate(callDetails.followup_calls.end_date ?? "");
          setFollowEndTime(callDetails.followup_calls.end_time ?? "");
          setFollowRemarks(callDetails.followup_calls.remarks ?? "");
          setSelectedFollowReminder(callDetails.followup_calls.reminders ?? []);
        } else {
          setIsToggled(false);
        }
      }
    } catch (err) {
      console.error("Error fetching call details:", err);
    }
  };

  const getTeamsToken = async () => {
    const request = {
      scopes: ["Calendars.Read", "Calendars.Read"],
      account: accounts[0],
    };

    try {
      const response = await instance.loginPopup(loginRequest);
      setTeamsToken(response.accessToken);
      /*  const response = await instance.acquireTokenSilent(request);
      setTeamsToken(response.accessToken); */
    } catch (error) {
      // No token means the backend would reject the save, so drop the toggle.
      setIsTeamsEnable(false);
      if (error.errorCode === "user_cancelled") {
        console.warn("User cancelled login — no further action needed.");
        // Optionally show a friendly message
      } else if (error instanceof InteractionRequiredAuthError) {
        console.error("Interaction required:", error);
      } else {
        console.error("Login error:", error);
      }
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Euclid Circular B', sans-serif",
        padding: "16px",
        backgroundColor: "#f8f9fb",
      }}
    >
      <div style={{ marginBottom: "32px" }}>
        <Row
          className="align-items-center justify-content-between"
          style={{ width: "100%" }}
        >
          <Col sm={12} md={6} lg={8}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{ width: "40px", height: "40px" }}
                onClick={() => navigate(-1)}
              >
                <img src={Back} alt="Back" />
              </div>
              <div
                style={{
                  fontWeight: "500",
                  fontSize: "20px",
                  color: "#172b4d",
                }}
              >
                New Call
              </div>
            </div>
          </Col>

          <Col sm={12} md={6} lg={4}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                justifyContent: "flex-end",
              }}
            >
              <button
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "#21272c",
                  height: "40px",
                  borderRadius: "100px",
                  border: "1px solid #d4dde7",
                  backgroundColor: "#ffffff",
                  padding: "10px 28px",
                  lineHeight: "100%",
                }}
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
              <button
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "#ffffff",
                  height: "40px",
                  borderRadius: "100px",
                  backgroundColor: "#3d4af5",
                  padding: "10px 28px",
                  lineHeight: "100%",
                  border: "none",
                }}
                onClick={submitCall}
              >
                {isLoading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </Col>
        </Row>
      </div>

      <div>
        <Row className="justify-content-between" style={{ width: "100%" }}>
          <Col sm={12} md={12} lg={12} xl={8}>
            <div
              style={{
                backgroundColor: "#ffffff",
                width: "100%",
                height: "100%",
                borderRadius: "24px",
                padding: "24px",
              }}
            >
              <Row>
                <Col sm={12}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                      marginBottom: "32px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "20px",
                        color: "#172b4d",
                      }}
                    >
                      Call information
                    </div>

                    <div
                      style={{
                        justifyContent: "start",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "20px",
                          color: "#172b4d",
                        }}
                      >
                        <img src={teamsIcon} alt="teams" />
                        Teams
                      </div>

                      <div
                        className="ms-2"
                        onClick={async () => {
                          if (!isTeamsEnable) {
                            getTeamsToken();
                          } else {
                            setTeamsToken("");
                          }
                          setIsTeamsEnable(!isTeamsEnable);
                        }}
                        style={{
                          width: "46px",
                          height: "24px",
                          backgroundColor: isTeamsEnable ? "#3D4AF5" : "#ccc",
                          borderRadius: "24px",
                          position: "relative",
                          cursor: "pointer",
                          transition: "0.3s",
                        }}
                      >
                        <div
                          style={{
                            height: "18px",
                            width: "18px",
                            backgroundColor: "#ffffff",
                            borderRadius: "50%",
                            position: "absolute",
                            top: "3px",
                            left: isTeamsEnable ? "24px" : "3px",
                            transition: "0.3s",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                      }}
                    >
                      Call Title<span style={{ color: "#ff4444" }}>*</span>
                    </div>
                    <div>
                      <input
                        value={callTitle}
                        onChange={(e) => setCallTitle(e.target.value)}
                        style={{
                          height: "44px",
                          width: "100%",
                          border: "0.8px solid #d4dde7",
                          padding: "16px",
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#212129",
                        }}
                        type="text"
                        placeholder="Enter here"
                      />
                      <span
                        style={{
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "#ff4444",
                        }}
                      >
                        {validations.title}
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "16px",
                  marginBottom: "16px",
                }}
              >
                <Col sm={12} xl={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#172b4d",
                      }}
                    >
                      Call start time
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Row style={{ width: "100%", margin: "0" }}>
                        <Col sm={12} md={6} style={{ paddingLeft: "0px" }}>
                          <div style={{ width: "100%" }}>
                            <input
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                              type="date"
                              style={{
                                height: "44px",
                                borderRadius: "10px",
                                border: "0.6px solid #d4dde7",
                                paddingLeft: "12px",
                                paddingRight: "12px",
                                backgroundColor: "#ffffff",
                                width: "100%",
                              }}
                            />
                          </div>
                        </Col>
                        <Col sm={12} md={6} style={{ paddingRight: "0px" }}>
                          <div style={{ width: "100%" }}>
                            <input
                              value={startTime}
                              onChange={(e) => setStartTime(e.target.value)}
                              type="time"
                              style={{
                                height: "44px",
                                borderRadius: "10px",
                                border: "0.6px solid #d4dde7",
                                paddingLeft: "12px",
                                paddingRight: "12px",
                                backgroundColor: "#ffffff",
                                width: "100%",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <span
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "#ff4444",
                      }}
                    >
                      {validations.start_time}
                    </span>
                  </div>
                </Col>

                <Col sm={12} xl={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#172b4d",
                      }}
                    >
                      Call end time
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Row style={{ width: "100%", margin: "0" }}>
                        <Col sm={12} md={6} style={{ paddingLeft: "0px" }}>
                          <div style={{ width: "100%" }}>
                            <input
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                              type="date"
                              style={{
                                height: "44px",
                                borderRadius: "10px",
                                border: "0.6px solid #d4dde7",
                                paddingLeft: "12px",
                                paddingRight: "12px",
                                backgroundColor: "#ffffff",
                                width: "100%",
                              }}
                            />
                          </div>
                        </Col>
                        <Col sm={12} md={6} style={{ paddingRight: "0px" }}>
                          <div style={{ width: "100%" }}>
                            <input
                              value={endTime}
                              onChange={(e) => setEndTime(e.target.value)}
                              type="time"
                              style={{
                                height: "44px",
                                borderRadius: "10px",
                                border: "0.6px solid #d4dde7",
                                paddingLeft: "12px",
                                paddingRight: "12px",
                                backgroundColor: "#ffffff",
                                width: "100%",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <span
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "#ff4444",
                      }}
                    >
                      {validations.end_time}
                    </span>
                  </div>
                </Col>
              </Row>

              <Row style={{ marginBottom: "16px" }}>
                <Col sm={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                      }}
                    >
                      Subject
                    </div>
                    <div>
                      <input
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        style={{
                          height: "44px",
                          width: "100%",
                          border: "0.8px solid #d4dde7",
                          padding: "16px",
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#212129",
                        }}
                        type="text"
                        placeholder="Enter here"
                      />
                      <span
                        style={{
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "#ff4444",
                        }}
                      >
                        {validations.subject}
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row style={{ marginBottom: "16px" }}>
                <Col sm={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                      }}
                    >
                      Related To
                    </div>
                    <div>
                      <input
                        value={related}
                        onChange={(e) => setRelated(e.target.value)}
                        style={{
                          height: "44px",
                          width: "100%",
                          border: "0.8px solid #d4dde7",
                          padding: "16px",
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#212129",
                        }}
                        type="text"
                        placeholder="Enter here"
                      />
                      <span
                        style={{
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "#ff4444",
                        }}
                      >
                        {validations.related_to}
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row style={{ marginBottom: "16px" }}>
                <Col sm={12} md={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                      }}
                    >
                      Call Type
                    </div>
                    <div>
                      <Form.Select
                        value={callType}
                        onChange={handleCallTypeChange}
                        style={{
                          height: "40px",
                          padding: "10px",
                          border: "1px solid #E5E5E5",
                          borderRadius: "8px",
                          background: "#FFFFFF",
                          color: "#1E1E1E",
                          width: "100%",
                          outline: "none",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                      >
                        <option value="">Select Call Type</option>
                        <option value="Inbound Call">Inbound Call</option>
                        <option value="Outbound Call">Outbound Call</option>
                        <option value="Follow-up Call">Follow-up Call</option>
                        <option value="Sales Call">Sales Call</option>
                        <option value="Support Call">Support Call</option>
                        <option value="Service Call">Service Call</option>
                        <option value="Cold Call">Cold Call</option>
                        <option value="Warm Call">Warm Call</option>
                        <option value="Demo Call">Demo Call</option>
                        <option value="Presentation Call">
                          Presentation Call
                        </option>
                        <option value="Feedback Call">Feedback Call</option>
                        <option value="Welcome Call">Welcome Call</option>
                        <option value="Onboarding Call">Onboarding Call</option>
                        <option value="Reminder Call">Reminder Call</option>
                        <option value="Escalation Call">Escalation Call</option>
                      </Form.Select>
                      <span
                        style={{
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "#ff4444",
                        }}
                      >
                        {validations.call_type}
                      </span>
                    </div>
                  </div>
                </Col>

                <Col sm={12} md={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                      }}
                    >
                      Purpose of Call
                    </div>
                    <div>
                      <SearchWithFreeTextAPI
                        onDropdownChange={handleCallPurposeDropdownChange}
                        onChangeSearch={handleCallPurposeOnChange}
                        apiUrl={apiUrl + `web/get_call_purpose`}
                        params={{}}
                        searchLimit={0}
                        placeholder={"Search Purpose"}
                        selectedValue={callPurpose}
                      />
                      <span
                        style={{
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "#ff4444",
                        }}
                      >
                        {validations.call_purpose}
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row style={{ marginBottom: "16px" }}>
                <Col sm={12} md={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                      }}
                    >
                      Call For<span style={{ color: "#ff4444" }}>*</span>
                    </div>
                    <div>
                      <Form.Select
                        value={callFor}
                        onChange={handleCallForChange}
                        style={{
                          height: "40px",
                          padding: "10px",
                          border: "1px solid #E5E5E5",
                          borderRadius: "8px",
                          background: "#FFFFFF",
                          color: "#1E1E1E",
                          width: "100%",
                          outline: "none",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                      >
                        <option value="" selected>
                          Select
                        </option>
                        <option value="Lead">Lead</option>
                        <option value="Account">Account</option>
                      </Form.Select>
                      <span
                        style={{
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "#ff4444",
                        }}
                      >
                        {validations.call_for}
                      </span>
                    </div>
                  </div>
                </Col>

                {callFor === "Lead" && (
                  <Col sm={12} md={6}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#21272c",
                        }}
                      >
                        Lead
                      </div>
                      <div>
                        {/*  <SearchWithFreeTextAPI onDropdownChange={handleLeadDropdownChange} onChangeSearch={handleLeadOnChange} apiUrl={apiUrl + `lead/autosuggestion`} params={{}} searchLimit={0} placeholder={"Search Purpose"} selectedValue={lead ? { value: lead.id, label: lead.name } : null} /> */}
                        <SearchWithAPI
                          onDropdownChange={handleLeadDropdownChange}
                          apiUrl={apiUrl + "lead/autosuggestion"}
                          params={{}}
                          placeholder={"Select"}
                          selectedOption={leadOption}
                        />
                      </div>
                    </div>
                  </Col>
                )}

                {callFor === "Account" && (
                  <Col sm={12} md={6}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#21272c",
                        }}
                      >
                        Account
                      </div>
                      <div>
                        <SearchWithAPI
                          onDropdownChange={handleLeadDropdownChange}
                          apiUrl={apiUrl + "get_customers"}
                          params={{}}
                          placeholder={"Select"}
                          selectedOption={leadOption}
                        />
                      </div>
                    </div>
                  </Col>
                )}
              </Row>

              <Row style={{ marginBottom: "16px" }}>
                <Col sm={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                        position: "relative",
                      }}
                    >
                      Add Participants<span style={{ color: "#ff4444" }}>*</span>
                    </div>
                    <label
                      htmlFor="searchInput"
                      style={{
                        height: "44px",
                        borderRadius: "10px",
                        padding: "16px 12px",
                        border: "1px solid #ebebeb",
                        backgroundColor: "#ffffff",
                        display: "flex",
                        gap: "12px",
                        alignItems: "center",
                        cursor: "text",
                      }}
                    >
                      <input
                        id="searchInput"
                        type="search"
                        placeholder="Search"
                        value={searchInput}
                        onChange={handleInputChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && searchInput.trim() !== "") {
                            e.preventDefault();
                            handleSelect(searchInput.trim());
                          }
                        }}
                        style={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#212129",
                          width: "100%",
                          height: "40px",
                          border: "none",
                          outline: "none",
                          background: "transparent",
                        }}
                      />
                    </label>

                    {searchInput && (
                      <div
                        style={{
                          background: "#fff",
                          border: "1px solid #ebebeb",
                          borderRadius: "8px",
                          marginTop: "4px",
                          zIndex: 10,
                          position: "absolute",
                          width: "100%",
                        }}
                      >
                        {filteredOptions.map((name, index) => (
                          <div
                            key={index}
                            onClick={() => handleSelect(name)}
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#212129",
                            }}
                          >
                            {name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                  >
                    {participants.map((name, index) => (
                      <div
                        key={index}
                        style={{
                          borderRadius: "10px",
                          padding: "4px 12px 4px 4px",
                          border: "1px solid #ebebeb",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          width: "fit-content",
                        }}
                      >
                        <div
                          style={{
                            height: "32px",
                            width: "32px",
                            borderRadius: "6px",
                            padding: "12px",
                            backgroundColor: "#eff0ff",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "500",
                            fontSize: "16px",
                            color: "#3d4af5",
                          }}
                        >
                          {getInitials(name)}
                        </div>
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#172b4d",
                          }}
                        >
                          {name}
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => handleRemove(name)}
                        >
                          <img
                            style={{ height: "16px" }}
                            src={Cancel}
                            alt="cancel"
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  {validations.participants && (
                    <span
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "#ff4444",
                        marginTop: "8px",
                        display: "block",
                      }}
                    >
                      {validations.participants}
                    </span>
                  )}
                </Col>
              </Row>

              <Row style={{ marginTop: "16px" }}>
                <Col sm={12} md={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                      }}
                    >
                      Reminder
                    </div>
                    <div>
                      {/*  <SearchWithFreeTextAPI onDropdownChange={handleReminderDropdownChange} onChangeSearch={handleReminderOnChange} apiUrl={apiUrl + `web/get_call_reminder`} params={{}} searchLimit={0} placeholder={"Choose Reminder"} selectedValue={reminder} /> */}
                      <AsyncSelect
                        isMulti
                        cacheOptions
                        value={selectedReminder}
                        loadOptions={getReminderData}
                        onChange={handleReminderOnChange}
                        defaultOptions
                        placeholder="Select reminder"
                        styles={multiselectCustomStyles}
                        isClearable={false}
                      />
                    </div>
                  </div>
                </Col>

                <Col sm={12} md={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#21272c",
                      }}
                    >
                      Remarks
                    </div>
                    <div style={{ width: "100%" }}>
                      <textarea
                        style={{
                          borderRadius: "10px",
                          height: "80px",
                          border: "0.6px solid #d4dde7",
                          padding: "12px",
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#21272c",
                          width: "100%",
                        }}
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        placeholder="Enter remarks"
                      ></textarea>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>

          <Col sm={12} md={12} lg={12} xl={4}>
            <div
              style={{
                backgroundColor: "#ffffff",
                widows: "100%",
                height: "fit-content",
                borderRadius: "24px",
                padding: "24px",
              }}
            >
              <Row>
                <Col sm={12}>
                  <div
                    style={{
                      justifyContent: "space-between",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "20px",
                        color: "#172b4d",
                      }}
                    >
                      Follow-up call
                    </div>

                    <div
                      onClick={() => setIsToggled(!isToggled)}
                      style={{
                        width: "46px",
                        height: "24px",
                        backgroundColor: isToggled ? "#3D4AF5" : "#ccc",
                        borderRadius: "24px",
                        position: "relative",
                        cursor: "pointer",
                        transition: "0.3s",
                      }}
                    >
                      <div
                        style={{
                          height: "18px",
                          width: "18px",
                          backgroundColor: "#ffffff",
                          borderRadius: "50%",
                          position: "absolute",
                          top: "3px",
                          left: isToggled ? "24px" : "3px",
                          transition: "0.3s",
                        }}
                      ></div>
                    </div>
                  </div>
                </Col>
              </Row>

              {isToggled && (
                <div
                  style={{
                    marginTop: "32px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <Row>
                    <Col sm={12}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "400",
                            fontSize: "14px",
                            color: "#21272c",
                          }}
                        >
                          Call Type
                        </div>
                        <div>
                          <Form.Select
                            value={followCallType}
                            onChange={handleFollowCallTypeChange}
                            style={{
                              height: "40px",
                              padding: "10px",
                              border: "1px solid #E5E5E5",
                              borderRadius: "8px",
                              background: "#FFFFFF",
                              color: "#1E1E1E",
                              width: "100%",
                              outline: "none",
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                          >
                            <option value="">Select Call Type</option>
                            <option value="Inbound Call">Inbound Call</option>
                            <option value="Outbound Call">Outbound Call</option>
                            <option value="Follow-up Call">
                              Follow-up Call
                            </option>
                            <option value="Sales Call">Sales Call</option>
                            <option value="Support Call">Support Call</option>
                            <option value="Service Call">Service Call</option>
                            <option value="Cold Call">Cold Call</option>
                            <option value="Warm Call">Warm Call</option>
                            <option value="Demo Call">Demo Call</option>
                            <option value="Presentation Call">
                              Presentation Call
                            </option>
                            <option value="Feedback Call">Feedback Call</option>
                            <option value="Welcome Call">Welcome Call</option>
                            <option value="Onboarding Call">
                              Onboarding Call
                            </option>
                            <option value="Reminder Call">Reminder Call</option>
                            <option value="Escalation Call">
                              Escalation Call
                            </option>
                          </Form.Select>
                          <span
                            style={{
                              fontWeight: "400",
                              fontSize: "12px",
                              color: "#ff4444",
                            }}
                          >
                            {validations.follow_up_call_type}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={12}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "400",
                            fontSize: "14px",
                            color: "#172b4d",
                          }}
                        >
                          Call start time
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <Row>
                            <Col sm={12} md={6}>
                              <div style={{ width: "100%" }}>
                                <input
                                  value={followStartDate}
                                  onChange={(e) =>
                                    setFollowStartDate(e.target.value)
                                  }
                                  style={{
                                    height: "44px",
                                    borderRadius: "10px",
                                    border: "0.6px solid #d4dde7",
                                    paddingLeft: "12px",
                                    paddingRight: "12px",
                                    backgroundColor: "#ffffff",
                                    width: "100%",
                                  }}
                                  type="date"
                                />
                              </div>
                            </Col>

                            <Col sm={12} md={6}>
                              <div style={{ width: "100%" }}>
                                <input
                                  value={followStartTime}
                                  onChange={(e) =>
                                    setFollowStartTime(e.target.value)
                                  }
                                  style={{
                                    height: "44px",
                                    borderRadius: "10px",
                                    border: "0.6px solid #d4dde7",
                                    paddingLeft: "12px",
                                    paddingRight: "12px",
                                    backgroundColor: "#ffffff",
                                    width: "100%",
                                  }}
                                  type="time"
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#ff4444",
                          }}
                        >
                          {validations.follow_up_start_time}
                        </span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={12}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "400",
                            fontSize: "14px",
                            color: "#172b4d",
                          }}
                        >
                          Call end time
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <Row>
                            <Col sm={6}>
                              <div style={{ width: "100%" }}>
                                <input
                                  value={followEndDate}
                                  onChange={(e) =>
                                    setFollowEndDate(e.target.value)
                                  }
                                  style={{
                                    height: "44px",
                                    borderRadius: "10px",
                                    border: "0.6px solid #d4dde7",
                                    paddingLeft: "12px",
                                    paddingRight: "12px",
                                    backgroundColor: "#ffffff",
                                    width: "100%",
                                  }}
                                  type="date"
                                />
                              </div>
                            </Col>
                            <Col sm={6}>
                              <div style={{ width: "100%" }}>
                                <input
                                  value={followEndTime}
                                  onChange={(e) =>
                                    setFollowEndTime(e.target.value)
                                  }
                                  style={{
                                    height: "44px",
                                    borderRadius: "10px",
                                    border: "0.6px solid #d4dde7",
                                    paddingLeft: "12px",
                                    paddingRight: "12px",
                                    backgroundColor: "#ffffff",
                                    width: "100%",
                                  }}
                                  type="time"
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#ff4444",
                          }}
                        >
                          {validations.follow_up_end_time}
                        </span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={12}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "400",
                            fontSize: "14px",
                            color: "#21272c",
                          }}
                        >
                          Reminder
                        </div>
                        <div>
                          {/* <SearchWithFreeTextAPI onDropdownChange={handleFollowReminderDropdownChange} onChangeSearch={handleFollowReminderOnChange} apiUrl={apiUrl + `web/get_call_reminder`} params={{}} searchLimit={0} placeholder={"Choose Reminder"} selectedValue={followReminder} /> */}
                          <AsyncSelect
                            isMulti
                            cacheOptions
                            value={selectedFollowReminder}
                            loadOptions={getReminderData}
                            onChange={handleFollowReminderOnChange}
                            defaultOptions
                            placeholder="Select reminder"
                            styles={multiselectCustomStyles}
                            isClearable={false}
                          />
                          <span
                            style={{
                              fontWeight: "400",
                              fontSize: "12px",
                              color: "#ff4444",
                            }}
                          >
                            {validations.follow_up_reminders}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={12}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "400",
                            fontSize: "14px",
                            color: "#21272c",
                          }}
                        >
                          Remarks
                        </div>
                        <div style={{ width: "100%" }}>
                          <textarea
                            style={{
                              borderRadius: "10px",
                              height: "80px",
                              border: "0.6px solid #d4dde7",
                              padding: "12px",
                              fontWeight: "400",
                              fontSize: "14px",
                              color: "#21272c",
                              width: "100%",
                            }}
                            value={followRemarks}
                            onChange={(e) => setFollowRemarks(e.target.value)}
                            placeholder="Enter remarks"
                          ></textarea>
                          <span
                            style={{
                              fontWeight: "400",
                              fontSize: "12px",
                              color: "#ff4444",
                            }}
                          >
                            {validations.follow_up_remarks}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CallsAdd;
